function startLoading(state) {
  state.isLoading = true
}

function stopLoading(state) {
  state.isLoading = false
}

function finishInitialStartup(state) {
  state.isInitialStartup = false
}

function isLoading(state) {
  return state.isLoading
}

function isInitialStartup(state) {
  return state.isInitialStartup
}

const loadingStore = {
  state: { isLoading: false, isInitialStartup: true },
  mutations: {
    startLoading,
    stopLoading,
    finishInitialStartup
  },
  getters: {
    isLoading,
    isInitialStartup
  }
}

export default loadingStore
